module.exports = "<app-reply-item *ngFor=\"let reply of replies | async\" [reply]=\"reply\">\n</app-reply-item>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/replies/replies-list/replies-list.component.html
// module id = ../../../../../src/app/replies/replies-list/replies-list.component.html
// module chunks = 1